import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/report-attendance-summaries',
    name: 'report-attendance-summary',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/report-attendance-summary/index.vue')
  }
]
